import AnketsScreen from './AnketsScreen';

export default AnketsScreen;
